module.exports = __webpack_public_path__ + "static/media/star.d304234d.png";